import type { ColumnDef } from "@tanstack/react-table"
import type { SubGroup } from "./data-table.js"
import { Button } from "../../components/button.js"
import { useNavigate } from "react-router-dom"

type ColumnOptions = {
  onEdit: (id: string) => void
  onDelete: (id: string) => void
}

export const groupColumns = ({ onEdit, onDelete }: ColumnOptions): ColumnDef<SubGroup>[] => [
  {
    accessorKey: "name",
    header: "Name",
    cell: ({ row }) => row.original.name,
  },
  {
    accessorKey: "code",
    header: "Code",
    cell: ({ row }) => row.original.code,
  },
  {
    accessorKey: "status",
    header: "Status",
    cell: ({ row }) => (
      <span
        className={`px-2 py-1 text-xs rounded ${
          row.original.status === "Enabled" ? "bg-green-200" : "bg-red-200"
        }`}
      >
        {row.original.status}
      </span>
    ),
  },
  {
    id: "actions",
    header: "Edit",
    cell: ({ row }) => {
      const navigate = useNavigate()
      const sub_group_id = row.original.sub_group_id
      return (
        <div className="flex gap-2">
          <Button onClick={() => navigate(`/sub-group/edit/${sub_group_id}`)}>Edit</Button>
          <Button variant="destructive" onClick={() => onDelete(sub_group_id)}>
            Delete
          </Button>
        </div>
      )
    },
  },
]